module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm07"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "underline"
  }, [_vm._v("AUTHOR’S NOTE")])])])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("I")])]), _vm._v("t has been twenty-four years since the first Center for Attitudinal Healing was established in Tiburon, California, and seventeen years since the first edition of "), _c('em', [_vm._v("Teach Only Love")]), _vm._v(" was published. What has happened in the ensuing years? For me personally, many miraculous events have occurred that were beyond my imagination twenty-four years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The principles of Attitudinal Healing, and the stories in this book that demonstrate them, continue to stand on their own as a testament to the power of Attitudinal Healing, not only for those facing catastrophic illnesses, but for all aspects of our lives. However, since this book was first published, the original seven principles have been expanded to twelve, and these new principles will be discussed in this new edition. I have also added a section on death and dying as well as one about my perceptions of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The original Center in Tiburon continued to grow and finally had to move to a larger space in Sausalito, California—a vacant school building that has proven to be an ideal home for us. We now have over three hundred volunteers and one hundred facilitators for the more than twenty-nine different groups that meet each week. There is a large Home and Hospital Division with over one hundred volunteers, and our Center is also working in elementary and high schools where children and staff are utilizing these principles in their everyday lives.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Since 1982 we have been working with adults and children who have AIDS, as well as children whose parents have AIDS. We created a poster that is used internationally—a cartoon by Jack Keeler of a boy saying, “I have AIDS. Please hug me. I can’t make you sick.” We have loss and grief groups for both children and adults. The Center is also actively working in prisons.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My wife and I, often accompanied by members of our staff, have traveled to such places as Russia, Croatia, Argentina, Chile, Australia, New Zealand, and Hawaii to give workshops and to consult with hospitals and other facilities. With other centers, we have responded to disasters such as the Oklahoma City bombing, establishing support groups as well as loss and grief groups.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We have a large volunteer training program, not only for our own Center but also for other agencies. Almost half of the people who now come to our Center participate in our Person to Person program. These people do not have catastrophic illnesses, but they come to learn how to apply the Attitudinal Healing principles of love and forgiveness in their own lives. The Center also continues to offer three-day workshops on Attitudinal Healing throughout the year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my amazement there are now more than 150 Centers or groups all over the world, including such diverse places as Ghana, West Africa, New Zealand, Australia, the Netherlands, Belgium, Switzerland, Italy, Argentina, Brazil, Russia, Germany, Croatia, as well as many more. As with the Sausalito Center, all of their direct services are free.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("There is now a separate organization, the Network for Attitudinal Healing, International, that serves as a bridge connecting the various autonomous Centers and as a source for the exchange of information and ideas. This organization also ")]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("helps coordinate an international conference on Attitudinal Healing that is held every two years. It is located at the Sausalito Center.")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At our Centers we do not believe it is our function to change people or “fix them up.” We are all there for our own healing and to learn to let go of what blocks our experience of love and prevents us from having peace of mind. We believe that by first healing our own hearts and minds, we then bring healing to the world we see. It is our absolute conviction that the most important gift we can give another person is our own inner peace and unconditional love. We believe that it is through forgiveness that our self-imposed blocks to love are removed and that we achieve this peace.")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("Gerald Jampolsky, M.D."), _c('br'), _vm._v("December, 1999")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bde17584","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authornote.vue
// module id = 69
// module chunks = 0